import * as React from 'react';

import {reduxForm} from 'redux-form';

import {Form} from './form';

export const FORM_NAME = 'sms_enrollment_form';

type Props = {
    saveFailedErrorMessage: string | null | undefined;
    handleSubmit: (eventOrSubmit?: any) => Promise<any>;
    invalid: boolean;
    pristine: boolean;
    submitting: boolean;
    reset: () => void;
    initialValues: any;
    isLoading: boolean;
    banner: React.ReactNode | null | undefined;
    isDisabled: boolean;
};

function EnrollmentFormConnectedComponent(props: Props) {
    return <Form {...props} />;
}

export const EnrollmentFormConnected = reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    // @ts-expect-error
})(EnrollmentFormConnectedComponent);
